import type {
  Category,
  CategoryDetails,
} from 'containers/admin/clients/client/tabs-components/goals-tab/types';

export type CategoryModification = Partial<Pick<Category, 'details'>> & {
  details?: CategoryDetails | null;
};

export type CategoryModifications = Record<string, CategoryModification>;

export const modifyCategories = (
  baseCategories: Category[],
  modifications: CategoryModifications
): Category[] =>
  baseCategories.map((category) => {
    const modification = modifications[category.name];

    if (modification) {
      return {
        ...category,
        ...modification,
      };
    }

    return category;
  });

export const categoryModifications: { volume: CategoryModifications } = {
  volume: {
    Topline: {
      details: null,
    },
  },
};
